import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import RootView from "./routes/RootView";
import BookView from "./routes/BookView";
import LoginView from "./routes/LoginView";
import SignupView from "./routes/SignupView";
import "@radix-ui/themes/styles.css";
import './App.css';
import {Theme} from "@radix-ui/themes";
import ConfirmSignupView from './routes/ConfirmSignupView';
import LandingPage from './routes/LandingPage';
import RecoverView from './routes/RecoverView';

const DOMParser = window.DOMParser

class OwnParser {
    parseFromString(markup: string, mime: string) {
        if (markup.indexOf('<title/>') !== -1) {
            markup = markup.replace('<title/>', '');
        }
        // @ts-ignore
        return new DOMParser().parseFromString(markup, mime)
    }
}

window.DOMParser = OwnParser;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: "/",
        element: <RootView />,
    },
    {
        path: "/book/:bookId",
        element: <BookView />,
    },
    {
        path: "/login",
        element: <LoginView />,
    },
    {
        path: "/signup",
        element: <SignupView />,
    },
    {
        path: "/confirmSignup",
        element: <ConfirmSignupView />
    },
    {
        path: "/landing",
        element: <LandingPage />,
    },
    {
        path: "/recover",
        element: <RecoverView />
    }
]);


root.render(
  <React.StrictMode>
      <Theme>
          <header className="App-header border-b border-slate-300 text-center">
              <img src={'/logoprotekids.png'}  width={200}/>
          </header>
          <div className={'flex flex-col bg-[#2294ae] bg-opacity-20'}>
              <RouterProvider router={router} />
          </div>
          <div className={'bg-white align-center text-center align-middle border-t-2 border-slate-300'}>
              <p className={'text-xs inline-block align-middle py-2'}>
                ProteKids Books | Todos os direitos reservados © | 2024
              </p>
              <p></p>
          </div>
      </Theme>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
